import {VStack, HStack, Space, Text, Box, Show} from 'platform/foundation';

import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, RequiredTestIdProps, suffixTestId} from 'shared/web';

interface OverviewTotalPriceProps extends RequiredTestIdProps {
  totalPriceWithoutVat: string | null;
  totalPriceWithVat?: string | null;
  totalPriceLabel?: string;
}

export function OverviewTotalPrice(props: OverviewTotalPriceProps) {
  return (
    <Box paddingTop={2} height="5%">
      <VStack height="100%" justify="center" data-testid={props['data-testid']}>
        <HStack align="center">
          <Text alternative>
            {props.totalPriceLabel ?? i18n.t('general.labels.totalPurchasePrice')}
          </Text>
          <Space fillAvailable />
          <Text color="tertiary" data-testid={suffixTestId('withoutVat', props)}>
            {`${props.totalPriceWithoutVat ?? EMPTY_PLACEHOLDER} ${i18n.t('general.labels.w/oVat')}`}
          </Text>
          <Show when={props.totalPriceWithVat}>
            <Space horizontal={2} />
            <Text alternative data-testid={suffixTestId('withVat', props)}>
              {props.totalPriceWithVat ?? EMPTY_PLACEHOLDER}
            </Text>
          </Show>
        </HStack>
      </VStack>
    </Box>
  );
}
